import gsx from 'styles'

const styles = {
  root: {
    zIndex: 2000,
    '&.sticky': {
      zIndex: 300,
    },
  },

  appbar: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'white',
    px: 2,
    borderBottom: 1,
    borderColor: 'divider',
    '&.inverted': {
      backgroundColor: 'secondary.main',
      color: 'secondary.contrastText',
    },
    '&.scrolled': {
      borderBottom: 'none!important',
      borderColor: 'unset!important',
    },
  },

  isAppraisalForm: {
    borderBottom: 0,
    backgroundColor: '#ECF0F1',
  },

  mobileMenu: {
    flexGrow: 1,
    justifyContent: 'flex-end',
    display: { xs: 'flex', sm: 'flex', md: 'none' },
    '& .MuiListItem-root': {
      p: 0,
    },
  },

  mobileMenuIcon: {
    '&.inverted': {
      color: 'white',
    },
  },

  whatsappTag: {
    cursor: 'pointer',
    color: '#00BB2D!important',
    padding: '8px!important',
    paddingRight: '0px!important',
    marginRight: 1,
    '& .MuiIconButton-root': {
      cursor: 'pointer',
      width: 'fit-content',
      height: 'fit-content',
      backgroundColor: 'unset',

      '& .MuiSvgIcon-root': {
        fontSize: 32,
      },
    },
    '&.inverted svg': {
      fill: '#fff!important',
    },
  },

  menu: {
    flexGrow: 1,
    justifyContent: 'flex-end',
    display: { xs: 'none', sm: 'none', md: 'flex' },
  },

  logoContainer: {

  },

  breadcrumbs: {
    position: 'absolute',
    bottom: 0,
    mt: 1,
    '& a': {
      textDecoration: 'none',
    },
    '& li': {
      fontSize: 10,
    },
    '&.inverted': {
      color: 'secondary.contrastText',
      '& li': {
        color: 'white',
      },
    },
  },

  leaveButton: {
    ...gsx.whiteButton,
    ml: 'auto',
    display: { xs: 'none', sm: 'none', md: 'flex' },
  },

  menuItem: {
    fontWeight: '500!important',
    color: '#202BB0',
    textTransform: 'none',
    borderRadius: '8px!important',
    mx: 1,
    // paddingX: 2,
    fontSize: '13px!important',
    lineHeight: '13px!important',
    backgroundColor: 'transparent!important',
    '&:hover': {
      color: '#202BB0',
      '&:after': {
        WebkitAnimation: 'scaleUp .6s cubic-bezier(0.694, 0.0482, 0.335, 1)',
        animation: 'scaleUp .6s cubic-bezier(0.694, 0.0482, 0.335, 1)',
        WebkitTransform: 'none',
        transform: 'none',
      },
    },
    '&:after': {
      content: '\'\'',
      position: 'absolute',
      top: '100%',
      height: '4px',
      left: 0,
      width: '100%',
      backgroundColor: '#202BB0',
      transform: 'scaleX(0)',
      transition: 'transform .6s cubic-bezier(0.694, 0.0482, 0.335, 1)',
      WebkitTransformOrigin: 'center',
      transformOrigin: 'center',
    },
    '&.selected': {
      borderRadius: '0px!important',
      color: 'secondary.main',
      '&:after': {
        WebkitAnimation: 'scaleUp .6s cubic-bezier(0.694, 0.0482, 0.335, 1)',
        animation: 'scaleUp .6s cubic-bezier(0.694, 0.0482, 0.335, 1)',
        WebkitTransform: 'none',
        transform: 'none',
      },
    },
    '&.inverted': {
      color: 'secondary.contrastText',
    },
    '&.selected.inverted': {
      backgroundColor: 'primary.main',
    },
  },

  drawer: {
    width: '100%!important',
    '& .MuiDrawer-paper': {
      width: '100%!important',
    },
  },

  drawerHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingX: 2,
  },

  mobileMenuListItem: {
    m: 8,
  },

  mobileMenuItem: {
    padding: 0,
    mb: 3,
    '& .MuiTypography-root': {
      fontWeight: '600!important',
      color: '#202BB0',
      margin: '0 auto',
      maxWidth: 250,
      lineHeight: '20px!important',
      fontSize: '16px!important',
    },
    '&.selected': {
      color: 'secondary.main',
      '& .MuiTypography-root': {
        fontWeight: '600!important',
        borderColor: 'secondary.main',
      },
    },
    borderBottom: 'none',
  },

  blueIcon: {
    color: '#202BB0',
  },

}

export default styles
